import { render, staticRenderFns } from "./text-overline.vue?vue&type=template&id=2293ace2&scoped=true&"
var script = {}
import style0 from "./text-overline.vue?vue&type=style&index=0&id=2293ace2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2293ace2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2293ace2')) {
      api.createRecord('2293ace2', component.options)
    } else {
      api.reload('2293ace2', component.options)
    }
    module.hot.accept("./text-overline.vue?vue&type=template&id=2293ace2&scoped=true&", function () {
      api.rerender('2293ace2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/text-overline.vue"
export default component.exports